import affiliateProgramsStore from 'shared/stores/affiliatePrograms.store'
import currenciesStore from 'shared/stores/currencies.store'
import productsStore from './stores/products.store'
import embeddableItemsStore from './stores/embeddableItems.store'
import sellerStore from './stores/seller.store'
import sellerFontsStore from './stores/sellerFonts.store'

export default {
  currenciesStore,
  productsStore,
  embeddableItemsStore,
  affiliateProgramsStore,
  sellerStore,
  sellerFontsStore,
}
